import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCU7aL2GW6J5UpXpFhf-w7ZtLNj2nUcCBM",
  authDomain: "solartc-3cfc4.firebaseapp.com",
  projectId: "solartc-3cfc4",
  storageBucket: "solartc-3cfc4.firebasestorage.app",
  messagingSenderId: "1088470355133",
  appId: "1:1088470355133:web:51e8993def4cdb97de7bd4"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);